<template>
  <section>
    <b-modal :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            ロボ作成
          </p>
        </header>
        <!-- 初期モード確認 -->
        <div class="card-content">
          <!-- ストアからロボ作成 - 02 -->
          <!-- <div class="step-03" v-if="step === 4">
            <p style="text-align: left; margin: 10px; width: 100%;"><b>ロボの会話はどのような形にしますか？</b></p>
            <div class="make-bot-button" style="height: 250px;" @click="step=5;type=5;randomSelectStore(category, type)">
              <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">シンプル</p>
              <p style="height: 200px; text-align: left;">シンプルに目的を達成したい人向けの会話内容です。</p>
            </div>
            <div class="make-bot-button" style="height: 250px;" @click="step=5;type=10;randomSelectStore(category, type)">
              <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">バランス</p>
              <p style="height: 200px; text-align: left;">はじめにロボがどのようなものか知りたい方向けです。</p>
            </div>
            <div class="make-bot-button" style="height: 250px;" @click="step=5;type=15;randomSelectStore(category, type)">
              <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">ワイド</p>
              <p style="height: 200px; text-align: left;">複雑ですが、幅広い対応ができるロボを作成できます。</p>
            </div>
          </div> -->
          <!-- ストアからロボ作成 - 03 -->
          <div class="step-03" v-if="step === 5">
            <div class="scenario-flow" style="width: 95%;">
              <BluePrintEdit :step="stepEdit" ref="bp" class="blueprint" style="height: 100%;"/>
            </div>
            <div v-if="selectStore['edit_list'] && (selectStore.edit_list.length - 1) >= stepEdit" style="margin-left: 20px;">
              <p style="text-align: left; margin: 10px; white-space: pre-line;"><b>{{selectStore.edit_list[stepEdit].description}}</b></p>
              <div style="padding: 5px;">
                <p style="text-align: left; margin: 10px; white-space: pre-line;"><b>メッセージ</b></p>
                <textarea class="input" style="width: 80%; margin-top: 7px;" v-model="selectStore.edit_list[stepEdit].scenario.mainmessage"></textarea>
                <p style="text-align: left; margin: 10px; white-space: pre-line;" v-if="selectStore.edit_list[stepEdit].scenario.status == 0"><b>選択肢</b></p>
                <input class="input" style="width: 80%; margin-top: 7px;" v-for="(s, i) in selectStore.edit_list[stepEdit].scenario.select" :key="i" v-model="s.message" v-if="selectStore.edit_list[stepEdit].scenario.status == 0"/>
              </div>
              <hr>
              <button class="button is-primary is-fullwidth" @click="$store.dispatch('chatbot/chatbotChangeScenario', selectStore.edit_list[stepEdit].scenario);stepEdit++">
                <span>次へ</span>
              </button>
            </div>
            <div v-if="selectStore['edit_list'] && (selectStore.edit_list.length - 1) < stepEdit" style="margin-left: 20px;">
              <p style="text-align: left; margin: 10px;"><b>ロボ名を入力してください</b></p>
              <b-input style="width: calc(100% - 20px); padding-left: 20px;" v-model="inputs.name" maxlength="30"></b-input>
              <hr>
              <button class="button is-primary is-fullwidth" @click="clickCreateChatBot()">
                インストールする
              </button>
            </div>
            <div v-if="!selectStore['edit_list']" style="margin-left: 20px;">
              <p style="text-align: left; margin: 10px;"><b>ロボ名を入力してください</b></p>
              <b-input style="width: calc(100% - 20px); padding-left: 20px;" v-model="inputs.name" maxlength="30"></b-input>
              <hr>
              <button class="button is-primary is-fullwidth" @click="clickCreateChatBot()">
                インストールする
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import createUUID from '@/functions/createUUID'
import BluePrint from '@/views/DashBoard/ChatBot/BluePrint'
import BluePrintEdit from '@/views/DashBoard/ChatBot/BluePrintEdit'
export default {
  name: 'ModalInstallChatBot',
  components: {
    BluePrint,
    BluePrintEdit
  },
  computed: {
    ...mapState('chatbot', ['stores', 'chatbots', '', 'scenarioTable', 'selectStore']),
    ...mapState('auth', ['user']),
  },
  data () {
    return {
      newValue: '既存',
      category: '',
      type: 0,
      selectedScenario: null,
      isCardModalActive: false,
      step: 5,
      stepEdit: 0,
      scenarioName: 'default',
      selectedName: 'No Name',
      inputs: {
        name: '',
        group: null,
        scenario_name: '',
        left: 0,
        used_hours: 0,
        order_num: 0,
        is_store: false,
        editor: []
      }
    }
  },
  watch: {
    isCardModalActive () {
      // this.$store.dispatch('chatbot/selectTemplate', {
      //   scenario_list: []
      // })
      if (this.isCardModalActive == false) this.step = 5
    }
  },
  methods: {
    randomSelectStore (category, type) {
      this.$store.dispatch('chatbot/randomSelectStore', {category: this.category, type: this.type})
    },
    selectTemplate (selected) {
      console.debug('Start selectTemplate')
      console.debug('selected: ' + selected)
      this.selectedName = selected.name
      this.$store.dispatch('chatbot/selectTemplate', selected)
      console.debug('End selectTemplate')
    },
    clickCreateChatBot () {
      console.debug('Start clickCreateChatBot')
      console.log('clickCreateChatBot: ' + this.user.companyID)
      this.inputs.scenario_name = createUUID()
      this.inputs.group = this.user.companyID
      this.inputs.editor.push(this.user.userHash)
      var id = this.inputs.scenario_name
      if (this.inputs.name !== '') {
        console.info('install bot name: ' + this.inputs.name)
        var inputs = JSON.parse(JSON.stringify(this.inputs))
        this.$store.dispatch('chatbot/createChatBot', inputs)
        for (var i in this.scenarioTable) {
          var scn = this.scenarioTable[i]
          // ストアロボ全パーツ編集可能対応のためコメントアウトして一律trueを格納するように変更
          // if (this.selectStore['edit_list'].length > 0) {
          //   var f = false
          //   for (var j in this.selectStore['edit_list']) {
          //     if (this.selectStore.edit_list[j].scenario.beforenode == scn.beforenode) f = TextTrackCue
          //   }
          //   if (f) scn['is_edit'] = true
          //   else scn['is_edit'] = false
          // } else if (scn.status == 0 || scn.status == 2) {
          //   scn['is_edit'] = false
          // } else {
          //   scn['is_edit'] = true
          // }
          scn['is_edit'] = true
          this.$store.dispatch('chatbot/saveScenario', { companyid: this.user.companyID, scenarioName: id, data: scn })
        }
        this.inputs.name = ''
        this.isCardModalActive = false
      } else {
        console.info('inputs.name is blank')
        alert('ロボ名を入力してください')
      }
      console.debug('End clickCreateChatBot')
    }
  }
}
</script>

<style scoped>
.template-box {
  width: calc(50% - 10px);
  margin: 5px;
  padding: 10px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow-y: scroll;
}
.template-box::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.template-item {
  margin: 10px;
  padding: 5px;
  width: calc(50% - 20px);
  border-radius: 5px;
  background: white;
  word-break: break-word;
  transition: 0.5s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.template-item:hover {
  transform: scale(1.05);
}
.scenario-flow {
  width: calc(50% - 10px);
  margin: 5px;
  height: 300px;
  position: relative;
  border: solid thin #ccc;
}
.official {
  font-size: 11.5px;
  margin-top: -5px;
  color: #777;
  display: flex;
  justify-content: center;
  border: solid thin #ccc;
  border-radius: 5px;
  line-height: 1.4;
}
.blueprint {
  height: 263px;
  width: 100%;
  overflow: scroll;
  display: block;
}
.blueprint::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.img-icon {
  width:  80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  border: solid thin #ccc;
}
.make-bot-button {
  height: 250px;
  width: 30%;
  margin: 10px 15px;
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  color: white;
  padding: 20px;
  border-radius: 15px;
  background: rgb(144, 37, 98);
  transition: 0.5s;
}
.make-bot-button:hover {
  transform: scale(1.05);
}
.step-01 {
  width: 100%; display: flex;
}
.step-03 {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalInstallChatBot.vue